import React, {useState} from "react";
import {
    Navbar,
    NavbarBrand,
    NavbarContent,
    NavbarItem,
    Link,
    Button,
    NavbarMenuToggle,
    NavbarMenu,
    NavbarMenuItem
} from "@nextui-org/react";
import Cookies from "universal-cookie";
import {useNavigate} from "react-router-dom";
import {FaDoorOpen} from "react-icons/fa6";
//import {AcmeLogo} from "./AcmeLogo.jsx";

export default function HeaderComponent({setRender}) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menu, setMenu] = useState("Home");
    const navigate = useNavigate();

    const menuItems = [
        {
            name: "Perfil",
            key: "profile",
        },
        {
            name: "Expendedoras",
            key: "machines",
        },
        {
            name: "Productos",
            key: "products",
        },
        {
            name: "Stock",
            key: "stock",
        },
        {
            name: "Transacciones",
            key: "transactions",
        }
    ]

    function toggleMenu(e) {
        setMenu(e.target.id);
        setRender(e.target.id);
        setIsMenuOpen(false);
        navigate("/dashboard");
    }

    function Signout(e) {
        const cookie = new Cookies();
        cookie.remove("userdata");
        navigate('/login');
    }

    return (
        <Navbar onMenuOpenChange={setIsMenuOpen} isMenuOpen={isMenuOpen}>
            <NavbarContent>
                <NavbarMenuToggle
                    aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                    className="sm:hidden"
                />
                <NavbarBrand>
                    <p className="text-inherit">EXPENDEDORA<span className="font-bold text-warning">ONLINE</span></p>
                </NavbarBrand>
            </NavbarContent>

            <NavbarContent className="hidden sm:flex gap-4" justify="center">
                {
                    menuItems.map((item, index) => (
                        <NavbarItem isActive={menu === item.key} key={index}>
                            <Link color={menu === item.key ? "warning" : "foreground"} href="#" id={item.key}
                                  onPress={toggleMenu}>
                                {item.name}
                            </Link>
                        </NavbarItem>
                    ))
                }
            </NavbarContent>
            <NavbarMenu>
                {
                    menuItems.map((item, index) => (
                        <NavbarMenuItem key={index}>
                            <Link color={menu === item.key ? "warning" : "foreground"} href="#" id={item.key}
                                  onPress={toggleMenu}>
                                {item.name}
                            </Link>
                        </NavbarMenuItem>
                    ))
                }
            </NavbarMenu>
        </Navbar>
    );
}
